import styled from 'styled-components';
import { Button, Table } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const TextError = styled.div`
	color: #c53030;
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.softBlack} !important;

	th {
		padding: 10px !important;
		text-transform: uppercase !important;
		font-weight: bold !important;
		&::after {
			width: 0 !important;
		}
	}
`;

export const ButtonStyled = styled(Button)`
	background-color: ${({ disabled }) =>
		!disabled ? '#dbdbdb' : color.primary} !important;
	border-radius: 0 !important;
	border: 0 !important;
	border-radius: 10px !important;
	color: ${({ disabled }) =>
		!disabled ? color.gray : color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.primary} !important;
		opacity: 0.6 !important;
	}

	@media (max-width: 768px) {
		height: 40px !important;
        min-height: unset !important;
		padding: 0 !important;
		font-size: 14px !important;
    }
`;

export const ButtonStyledSimular = styled(Button)`
	background-color: ${color.primary} !important;
	border: 0 !important;
	width: 50%;
	border-radius: 10px !important;
	color: ${color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.greenDark} !important;
	}

	&:focus {
		background-color: ${color.primary} !important;
	}

	@media (max-width: 768px) {
		height: 50px !important;
        min-height: unset !important;
		padding: 0 !important;
		font-size: 14px !important;
    }
`;

export const TableStyled = styled(Table)`
	@media (max-width: 768px) {
		display: block;
		width: 100% !important;

		thead {
			display: none !important;
		}

		tbody, tr, td {
			display: block !important;
			width: 100% !important;
			height: auto !important;
			box-sizing: border-box !important;
		}

		tbody tr {
			margin-bottom: 16px !important;
			background-color: #ffffff !important;
			border: 1px solid #e2e8f0 !important;
			border-radius: 8px !important;
			padding: 12px 16px !important;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
		}

		tbody td {
			display: flex !important;
			flex-direction: column !important;
			align-items: flex-start !important;
			padding: 8px 0 !important;
			border: none !important;
			border-bottom: 1px solid #f1f5f9 !important;
			font-size: 15px !important;
			font-weight: 500 !important;
			color: #1e293b !important;
			text-align: left !important;

			&:last-child {
				border-bottom: none !important;
			}

			&::before {
				content: attr(data-label);
				display: block !important;
				font-weight: 700 !important;
				font-size: 11px !important;
				color: #64748b !important;
				text-transform: uppercase;
				letter-spacing: 0.5px;
				margin-bottom: 4px !important;
			}
		}
	}
`;


export const ButtonStyledGerarLink = styled(Button)`
	background-color: ${color.secondary} !important;
	border: 0 !important;
	width: 50%;
	border-radius: 10px !important;
	color: ${color.black} !important;
	opacity: 1 !important;

	&:hover {
		 background-color: ${color.blueDark} !important;
	}

	&:focus {
		background-color: ${color.secondary} !important;
	}
`;
